<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                @click="$router.push('/fertilization/fertilizers/create')"
              >
                <em class="fa fa-plus"></em>
                {{ $t('fertilization.fertilizer_add') }}
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
          <el-dialog
            v-if="isShow()"
            :title="nameAreasSelected"
            :visible.sync="modals.read"
            width="50%"
          >
            <p>
              {{ $t('common_words.selected_record_info') }}
            </p>
            <div class="card" v-if="rowData">
              <div class="card-body" v-if="rowData">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.code') }}:</strong>
                        </h6>
                        {{ rowData.code }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.name') }}:</strong>
                        </h6>
                        {{ rowData.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.value') }}:</strong>
                        </h6>
                        ${{ rowData.value }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('labor.unit_of_measure') }}:</strong>
                        </h6>
                        {{ rowData.unit_measure }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{ $t('common_words.conversion_factor') }}:</strong
                          >
                        </h6>
                        {{ rowData.conversion_factor ? rowData.conversion_factor  : '' }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{
                              $t('samples.nutrient_percentage_contribution')
                            }}:</strong
                          >
                        </h6>
                        <ul>
                          <li
                            v-for="value in rowData.fertilizer_nutrients"
                            :key="value.id"
                          >
                            {{ value.nutrient.description }}:
                            {{ value.percentage }}%
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer footer-date-at" v-if="rowData">
                <p class="text-muted">
                  <small
                    >{{ $t('common_words.created_on') }}:
                    {{ rowData.created_at }}</small
                  >
                </p>
              </div>
            </div>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <el-table
              stripe
              :default-sort="{ prop: 'name', order: 'descending' }"
              :data="queriedData"
              max-height="530"
              style="width: 100%"
              :border="true"
            >
              <el-table-column
                type="index"
                width="80"
                :resizable="false"
                :align="'center'"
              ></el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :formatter="column.formatter"
                :fixed="column.fixed"
                :sortable="column.sortable"
                :align="column.align"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                :min-width="110"
                :label="$t('common_words.operations')"
                fixed="right"
                :resizable="false"
              >
                <template slot-scope="props">
                  <div class="text-center">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="$t('common_words.view')"
                      class="btn-info btn-simple btn-link custom-margin-actions"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.edit')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <em class="fa fa-edit custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="handleDelete(props.$index, props.row)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="exportToPDF"
            >
              <em class="fa fa-file-pdf-o"></em>
              {{ $t('common_words.export_to_pdf') }}
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="exportToExcel"
            >
              <em class="fa fa-file-excel-o"></em>
              {{ $t('common_words.export_to_excel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixinMasters from 'src/util/mixinMasters';
import { Axios } from 'src/class/Axios.js';
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinExport } from 'src/mixins/mixin-export';
import i18n from 'src/i18n';
import MixinMenu from 'src/util/mixinMenu';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import configTable from './fertilizerTable';

export default {
  computed: {
    ...configTable().Search,
  },

  data() {
    return {
      fertilizerForm: {
        code: null,
        name: null,
        unit_measure: null,
        conversion_factor: null,
        business_id: null,
      },
      modelValidations: {
        name: {
          required: true,
        },

        unit_measure: {
          required: true,
        },

        conversion_factor: {
          required: true,
        },
      },
      businesses: null,
      all_nutrients: null,
      pagination: {},
      tableColumns: [],
    };
  },

  mixins: [mixinMasters, MixinPermissions, MixinExport, MixinMenu],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    handleView(index, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(index, row) {
      row.url_path_form = '/fertilization/fertilizers/edit';
      this.title = `${i18n.t('fertilization.fertilizer_edit')} :  ${row.name}`;
      this.fertilizerForm = Object.assign({}, row);
      sessionStorage.setItem('editForm', JSON.stringify(this.fertilizerForm));
      this.$router.push({ path: '/fertilization/fertilizers/edit' });
    },

    handleDelete(index, row) {
      this.fertilizerForm = row;
      SweetAlert.delete(
        `${i18n.t('fertilization.the_fertilizer')}   ${
          this.fertilizerForm.name
        }`
      ).then((result) => {
        if (result.value) this.deleteFertilizer();
      });
    },

    deleteFertilizer() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.fertilizerForm.route = 'fertilization/fertilizers';
        Axios.destroyMaster(this.fertilizerForm)
          .then((response) =>
            this.modifyTable(2, this.fertilizerForm.id, response)
          )
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    exportToPDF() {
      let data = {};
      data.route = 'fertilization/fertilizers/pdf';
      data.name_file = `${i18n.t('fertilization.fertilizer')}.pdf`;

      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    exportToExcel() {
      let data = {};
      data.route = 'fertilization/fertilizers/excel';
      data.name_file = `${i18n.t('fertilization.fertilizer')}.xlsx`;

      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();

      Axios.getMasters('fertilization/fertilizers')
        .then((response) => {
          this.tableData = response.data.data;
          this.searchFuse(
            this.tableColumns.map((prop) => {
              return prop.prop;
            })
          );
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));

      Axios.getMasters('businesses/only')
        .then((response) => {
          this.businesses = response.data.data;
        })
        .catch((error) => this.showMessageErrors(error));

      Axios.getMasters('fertilization/nutrients')
        .then((response) => {
          this.all_nutrients = response.data.data;
        })
        .catch((error) => this.showMessageErrors(error));

      this.showHideLoading();
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('fertilization');
    this.showHideLoading(true);
  },

  destroyed() {
    this.deselectedItemOnMenu('fertilization');
  },
};
</script>
